import { render, staticRenderFns } from "./ticket-status-select.vue?vue&type=template&id=3c301f0e&scoped=true&"
import script from "./ticket-status-select.vue?vue&type=script&lang=js&"
export * from "./ticket-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c301f0e",
  null
  
)

export default component.exports